export default Object.freeze({
  Pending: 0,
  Execution: 1,
  Finished: 2,
  Voided: 3,
  Error: 4,
});
